import React from 'react'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateFormTrainComponent } from '../../components/Officer/CreateFormTrainComponent'
import { Footer } from "../../components/share/Footer";

export const CreateFormTrainContainer = () => {
  const titleName =
    "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการฝึกอบรม";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <CreateFormTrainComponent />
      <Footer />
    </div>
  );
}
